/* global OneSignal */
import React, { useState, useEffect } from "react";
import "./login.css";
import { useNavigate } from "react-router-dom";
import { logindata } from "../../services/api";
import { tokensave } from "../../services/common";
import { applyOneSignalIdentity } from "../../services/onesignal";

function registerDevice(userDetails, token) {
  const temp = new FormData();
  temp.append("academy_id", userDetails.academy_id || "1");
  temp.append("login_user_id", userDetails.id);
  temp.append("role_id", userDetails.role);
  temp.append("device_token", token);

  // The response carries the tag set for this household, which is what makes
  // the browser addressable without the backend storing its token.
  return tokensave(temp).then((response) => {
    if (response && response.status === true) {
      applyOneSignalIdentity(response.data);
    }
  });
}

function saveDeviceToken(userDetails, attempt = 0) {
  const rawToken = localStorage.getItem("notitoken");
  if (rawToken) {
    const token = rawToken.replace(/^"|"$/g, ""); // strip JSON quotes if any
    registerDevice(userDetails, token);
  } else if (attempt < 20) {
    // OneSignal assigns the subscription ID asynchronously and stores it in
    // localStorage via the change listener in index.html — retry for up to ~20s.
    setTimeout(() => saveDeviceToken(userDetails, attempt + 1), 1000);
  } else {
    // Push permission was never granted, so there is no subscription id. Still
    // register, so the identity tags are in place if the user enables
    // notifications later from Settings.
    registerDevice(userDetails, "");
  }
}

function Login() {
  // const passInputRef = useRef();
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  const [pass, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    captcha();
    if (localStorage.getItem("Roleid") === "1") {
      navigate("/superadmin/dashboard");
    }
  }, []);

  const [capvalue, setCapvalue] = useState("");
  const [ecapvalue, setECapvalue] = useState("");

  function captcha() {
    setCapvalue("");
    var a = Math.ceil(Math.random() * 10) + "";
    var b = Math.ceil(Math.random() * 10) + "";
    var c = Math.ceil(Math.random() * 10) + "";
    var d = Math.ceil(Math.random() * 10) + "";
    var e = Math.ceil(Math.random() * 10) + "";
    var f = Math.ceil(Math.random() * 10) + "";
    var g = Math.ceil(Math.random() * 10) + "";
    setCapvalue(a + "" + b + "" + c + "" + d + "" + e + "" + f + "" + g);
  }

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setECapvalue(e.target.value);
    }
  };

  function Submitlogin(e) {
    e.preventDefault();
    setErrorMessage("");

    setSubmitted(true);
    const tempData = {
      username: user,
      password: pass,
    };
    if (tempData.username !== "" && tempData.password !== "") {
      if (ecapvalue !== "") {
        if (capvalue === ecapvalue) {


          logindata(tempData).then((response) => {
            if (response.status === true) {
              console.log(response);
              localStorage.setItem("UID", response.data.user_details.id);
              localStorage.setItem("User", response.data.user_details.name);
              localStorage.setItem("Role", response.data.user_details.role);
              localStorage.setItem("password", pass);
              localStorage.setItem("token", response.data.token);
              localStorage.setItem("academy", response.data.user_details.academy_id);
              if (response.data.user_details.role != 1) {
                localStorage.setItem("AAcademy", response.data.user_details.academy_id);
              }
              const userDetails = response.data.user_details;
              saveDeviceToken(userDetails);


              if (response.data.user_details.role == 1) {
                navigate("/superadmin/dashboard");
              } else if (response.data.user_details.role === 2) {
                navigate("/superadmin/dashboard");
              } else if (response.data.user_details.role === 4) {
                navigate("/student/dashboard");
              } else if (response.data.user_details.role === 5) {
                navigate("/teacher/dashboard");
              } else if (response.data.user_details.role === 6) {
                navigate("/workers/dashboard");
              } else if (response.data.user_details.role === 7) {
                navigate("/accounts/dashboard");
              } else if (response.data.user_details.role === 8) {
                navigate("/warden/dashboard");
              } else if (response.data.user_details.role === 9) {
                navigate("/driver/dashboard");
              } else if (response.data.user_details.role === 10) {
                navigate("/frontdesk/dashboard");
              }
            } else {
              setErrorMessage(response.message);
            }
          });
        } else {
          setErrorMessage("Captcha didn't match");
        }
      }
    }
  }

  return (
    <div>
      <main id="loginpage">
        <div className="container">
          <div className="loginpage_logo">
            {/* alt="dturn IT Solutions (P) Ltd" */}
            <img
              src={require("../../assets/images/logo/logo.png")}
              height="60"
              alt="Tracking academy"
            />
          </div>
          <div className="loginpage_section">
            <div className="loginpage_secionone">
              <div className="loginpage_sectionone_left">
                {/* <h1>dturn IT Solutions (P) Ltd</h1> */}
                <h1>Tracking Academy</h1>
                <h5>
                  A student tracking system is a software that keeps a track of student performance, attendance, behavior, and participation in school activities throughout their academic education.
                </h5>
                {/* <h4>
                  Supported By
                </h4>
                <img
              src={require("../../assets/images/logo/logo1.png")}
              height="60"
              alt="AMY"
            /> */}
                {/* <h4>
                  For Support
                </h4>
                <a href="mailto: support@trackingacademy.in">support@trackingacademy.in</a> */}
              </div>
            </div>

            <div className="loginpage_seciontwo">
              <div className="loginpage_sectiontwo_form">
                <form className="form">
                  {/* <h6 className="text-center">Welcome to dturn IT Solutions (P) Ltd!</h6> */}
                  <h6 className="text-center">Welcome to Tracking Academy!</h6>
                  <h2 className="text-center">Member Login</h2>
                  <fieldset className="username">
                    <label>Username <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      placeholder="Enter your Username"
                      value={user}
                      autoComplete="off"
                      onChange={(e) => setUser(e.target.value)}
                    />
                    {submitted && !user && (
                      <span className="text-danger">Username is required</span>
                    )}
                  </fieldset>

                  <fieldset className="password">
                    <label>Password<span className="text-danger"> *</span></label>
                    <input
                      type="password"
                      placeholder="Enter your Password"
                      value={pass}
                      onChange={(e) => setPassword(e.target.value)}
                      // ref={passInputRef}
                      minLength={6}
                      autoComplete="off"
                    />
                    {submitted && !pass && (
                      <span className="text-danger">Password is required</span>
                    )}
                  </fieldset>
                  <div className="form-group d-flex">
                    <div className="w-40">
                      <input type="text" value={capvalue} readOnly />
                    </div>
                    <div className="w-20 text-center">
                      <a
                        onClick={captcha}
                        className="fa fa-fw fa-refresh refresh"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                      ></a>
                    </div>
                    <div className="w-40">
                      <input
                        type="text"
                        placeholder="Enter Here"
                        maxLength={12}
                        autoComplete="off"
                        value={ecapvalue}
                        onChange={handleChange}
                        onPaste={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                        onCopy={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                      />
                      {submitted && !ecapvalue && (
                        <span className="text-danger">Captcha is required</span>
                      )}
                    </div>
                  </div>
                  {errorMessage && (
                    <span className="text-danger"> {errorMessage} </span>
                  )}
                  <button type="submit" className="btn" onClick={Submitlogin}>
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>
          {/* <div className="loginpage_footer text-right">
            <span>© 2024 Tracking Academy All Rights Reserved</span>
          </div> */}
        </div>
      </main>
      <div className="footer">
        <div className="row">
          <div className="col-md-6 text-left">
            {/* <span>Copyrights © 2026 <a href="https://dturn.io" target="_blank" className='text-danger' >dturn IT Solutions (P) Ltd</a>. All Rights Reserved</span> */}
            <span>Copyrights © 2026 <a href="https://trackingacademy.in/" target="_blank" className='text-danger' >Tracking Academy</a>. All Rights Reserved</span>
          </div>
          <div className="col-md-6 text-end">
           {/*  <span>Powered by <a href="https://amytechnologies.in/" target="_blank" className="dark-primary font-weight-bold">AMY Technologies</a></span>*/}
          </div> 
        </div>
      </div>
    </div>
  );
}

export default Login;
